import { SpeedTest } from '../components/speedtest/SpeedTest';
const Index = () => (
  <div className="w-full min-h-screen bg-[hsl(var(--st-bg))] text-[hsl(var(--st-text))]">
    <SpeedTest />
  </div>
);

export default Index;